import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Adg4Skeleton } from "@/components/adg4/skeleton/src/skeleton";

const siteInfoContainerCss = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "64px",
    gap: token("space.200")
});

const sitenameIconCss = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

const sitenameAndAvatarContainerCss = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "10px",
    position: "relative",
    height: "64px"
});

const containerCss = css({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    flexGrow: "1",
    alignSelf: "stretch"
});

export const JiraSiteSkeleton = () => {
    return (
        <div data-testid="jira-site-skeleton" css={containerCss}>
            <div css={siteInfoContainerCss}>
                <div css={sitenameIconCss}>
                    <Adg4Skeleton width="64px" height="64px" />
                </div>
                <div css={sitenameAndAvatarContainerCss}>
                    <Adg4Skeleton width="300px" height="22px" />
                    <Adg4Skeleton width="160px" height="22px" />
                </div>
            </div>
            <div>
                <Adg4Skeleton width="120px" height="40px" />
            </div>
        </div>
    );
};
